import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { Typography } from '../Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { colorPalette } from '../../colorPalette';
import InfoIcon from '@mui/icons-material/Info';
import format from 'date-fns/format';
import { PaymentSummaryHeader } from './PaymentSummaryHeader';
import { PaymentSummary } from './PaymentSummary';
import { paymentSummaryWrapperStyles } from './PaymentSummaryWrapper.style';
export const PaymentSummaryWrapper = ({ canRetract, summaryLines, creationDate }) => {
    const transferSummaryWrapperClasses = paymentSummaryWrapperStyles();
    return (React.createElement(Box, { sx: transferSummaryWrapperClasses.transferSummaryWrapperContainer },
        React.createElement(PaymentSummaryHeader, null),
        React.createElement(Divider, { sx: transferSummaryWrapperClasses.divider }),
        React.createElement(PaymentSummary, Object.assign({}, summaryLines)),
        canRetract && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { sx: transferSummaryWrapperClasses.divider }),
            React.createElement(Box, { sx: transferSummaryWrapperClasses.iconContainer }, creationDate ? (React.createElement(React.Fragment, null,
                React.createElement(CalendarMonthIcon, { fontSize: "small", sx: transferSummaryWrapperClasses.iconBorder }),
                React.createElement(Stack, { spacing: 0.5 },
                    React.createElement(Typography, { variant: 'body-default-semibold', sx: { color: colorPalette.gray900 } }, "Date de la demande"),
                    React.createElement(Typography, { variant: 'body-default-regular', sx: { color: colorPalette.gray900 } }, `${new Date(creationDate).toLocaleDateString()} à  ${format(new Date(creationDate), 'HH')}h${format(new Date(creationDate), 'mm')}`)))) : (React.createElement(Paper, { sx: transferSummaryWrapperClasses.infoCard },
                React.createElement(Box, { sx: transferSummaryWrapperClasses.infoBox },
                    React.createElement(InfoIcon, { sx: transferSummaryWrapperClasses.infoIcon })),
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: 'body-default-regular', sx: transferSummaryWrapperClasses.infoText }, "Une fois la demande effectu\u00E9e vous ne pourrez plus vous r\u00E9ctracter.")))))))));
};
